// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReviewerListTable.css */

.action-btn {
    transition: all 0.3s ease;
    border-radius: 8px;
    font-weight: 500;
    box-shadow: 0 0 0 transparent;
  }
  
.action-btn:hover {
  /* transform: translateY(-2px); */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.issue-btn:hover {
  background-color: #52c41a !important;
  color: #fff !important;
  border-color: #52c41a !important;
}

.edit-btn:hover {
  background-color: #1677ff !important;
  color: #fff !important;
  border-color: #1677ff !important;
}

.delete-btn:hover {
  background-color: #ff4d4f !important;
  color: #fff !important;
  border-color: #ff4d4f !important;
}
.table-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.add-new-btn {
  background: linear-gradient(135deg, #1677ff, #69b1ff);
  border: none;
  color: white;
  font-weight: bold;
  padding: 8px 20px;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(22, 119, 255, 0.3);
}

.add-new-btn:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 6px 16px rgba(22, 119, 255, 0.5);
  background: linear-gradient(135deg, #4096ff, #91caff);
}
`, "",{"version":3,"sources":["webpack://./src/views/journal_list/css/JournalListTable.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;EAC/B;;AAEF;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,qDAAqD;AACvD","sourcesContent":["/* ReviewerListTable.css */\n\n.action-btn {\n    transition: all 0.3s ease;\n    border-radius: 8px;\n    font-weight: 500;\n    box-shadow: 0 0 0 transparent;\n  }\n  \n.action-btn:hover {\n  /* transform: translateY(-2px); */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.issue-btn:hover {\n  background-color: #52c41a !important;\n  color: #fff !important;\n  border-color: #52c41a !important;\n}\n\n.edit-btn:hover {\n  background-color: #1677ff !important;\n  color: #fff !important;\n  border-color: #1677ff !important;\n}\n\n.delete-btn:hover {\n  background-color: #ff4d4f !important;\n  color: #fff !important;\n  border-color: #ff4d4f !important;\n}\n.table-header {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n}\n\n.add-new-btn {\n  background: linear-gradient(135deg, #1677ff, #69b1ff);\n  border: none;\n  color: white;\n  font-weight: bold;\n  padding: 8px 20px;\n  border-radius: 12px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(22, 119, 255, 0.3);\n}\n\n.add-new-btn:hover {\n  transform: translateY(-2px) scale(1.03);\n  box-shadow: 0 6px 16px rgba(22, 119, 255, 0.5);\n  background: linear-gradient(135deg, #4096ff, #91caff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
